<p-toast [style]="{marginTop: '80px'}"></p-toast>

<div class="container-fluid content-ops-page">
    <h2>Content Ops</h2>

    <!-- ── SECTION 1: AI CONTENT GENERATOR ───────────────────────────────── -->
    <p-card header="AI Content Generator Status" styleClass="mb-4">
        <div class="generator-meta mb-3">
            <span class="me-4"><strong>Last Run:</strong> —</span>
            <span class="me-4"><strong>Next Scheduled:</strong> Sunday 3:00 AM EST</span>
            <span><strong>Status:</strong> <span class="status-badge status-idle">Idle</span></span>
        </div>

        <div class="stats-row mb-3">
            <div class="stat-card">
                <div class="stat-value">{{generatorStats.totalGenerated}}</div>
                <div class="stat-label">Generated (this month)</div>
            </div>
            <div class="stat-card success">
                <div class="stat-value">{{generatorStats.approved}}</div>
                <div class="stat-label">Approved</div>
            </div>
            <div class="stat-card danger">
                <div class="stat-value">{{generatorStats.rejected}}</div>
                <div class="stat-label">Rejected</div>
            </div>
            <div class="stat-card warning">
                <div class="stat-value">{{generatorStats.pendingReview}}</div>
                <div class="stat-label">Pending Review</div>
            </div>
        </div>

        <p-table [value]="recentItems" [loading]="contentHealthLoading" responsiveLayout="scroll" styleClass="p-datatable-sm mb-3">
            <ng-template pTemplate="header">
                <tr>
                    <th>Title</th>
                    <th>Type</th>
                    <th>Location</th>
                    <th>Status</th>
                    <th>Generated At</th>
                    <th>Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>{{item.title}}</td>
                    <td>{{item.contentType}}</td>
                    <td>{{item.location}}</td>
                    <td><span class="status-badge" [ngClass]="'status-' + item.status?.toLowerCase()">{{item.status}}</span></td>
                    <td>{{item.generatedAt | date:'MM/dd/yyyy'}}</td>
                    <td>
                        <a [routerLink]="['/content-list']" class="p-button p-button-text p-button-sm me-1">View</a>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr><td colspan="6">No recent AI-generated content.</td></tr>
            </ng-template>
        </p-table>

        <button pButton type="button" label="Run Now" icon="pi pi-play"
            class="p-button-outlined"
            [loading]="generatorLoading"
            (click)="runGenerator()">
        </button>
    </p-card>

    <!-- ── SECTION 1b: PENDING REVIEW ───────────────────────────────────── -->
    <p-card header="Pending Review" styleClass="mb-4">

        <ng-container *ngIf="!pendingReviewLoading && pendingItems.length === 0">
            <div class="pending-empty-state">
                <i class="pi pi-check-circle pending-empty-icon"></i>
                <span>No content pending review — all caught up.</span>
            </div>
        </ng-container>

        <p-table *ngIf="pendingItems.length > 0 || pendingReviewLoading"
            [value]="pendingItems"
            [loading]="pendingReviewLoading"
            responsiveLayout="scroll"
            styleClass="p-datatable-sm mb-3">
            <ng-template pTemplate="header">
                <tr>
                    <th>Content Type</th>
                    <th>Location / Property</th>
                    <th>Prompt Version</th>
                    <th>Quality Score</th>
                    <th>Created</th>
                    <th>Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>{{item.contentTypeLabel}}</td>
                    <td>{{item.locationDisplay}}</td>
                    <td><code>{{item.promptVersionKey}}</code></td>
                    <td>
                        <span *ngIf="item.qualityScore != null"
                            class="qs-badge" [ngClass]="qualityScoreClass(item.qualityScore)">
                            {{item.qualityScore}}
                        </span>
                        <span *ngIf="item.qualityScore == null" class="text-muted">—</span>
                    </td>
                    <td>{{item.createDate | date:'MM/dd/yyyy'}}</td>
                    <td>
                        <div class="pending-actions">
                            <button pButton type="button" label="Approve" icon="pi pi-check"
                                class="p-button-success p-button-sm p-button-outlined me-1"
                                (click)="approveContent(item)">
                            </button>
                            <button pButton type="button" label="Preview" icon="pi pi-eye"
                                class="p-button-info p-button-sm p-button-outlined me-1"
                                (click)="previewContent(item)">
                            </button>
                            <button pButton type="button" label="Regenerate" icon="pi pi-refresh"
                                class="p-button-secondary p-button-sm p-button-outlined me-1"
                                (click)="regenerateContent(item)">
                            </button>
                            <button *ngIf="!rejectInputVisible[item.contentId]"
                                pButton type="button" label="Reject" icon="pi pi-times"
                                class="p-button-danger p-button-sm p-button-outlined"
                                (click)="showRejectInput(item)">
                            </button>
                            <div *ngIf="rejectInputVisible[item.contentId]" class="reject-inline">
                                <input pInputText type="text" placeholder="Reason (optional)"
                                    [(ngModel)]="rejectReason[item.contentId]"
                                    class="reject-reason-input me-1" />
                                <button pButton type="button" label="Confirm" icon="pi pi-check"
                                    class="p-button-danger p-button-sm me-1"
                                    (click)="confirmReject(item)">
                                </button>
                                <button pButton type="button" icon="pi pi-times"
                                    class="p-button-text p-button-sm"
                                    (click)="cancelReject(item)">
                                </button>
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr><td colspan="6">No pending items found.</td></tr>
            </ng-template>
        </p-table>

        <button pButton type="button" label="Refresh" icon="pi pi-refresh"
            class="p-button-outlined p-button-sm"
            [loading]="pendingReviewLoading"
            (click)="loadPendingReview()">
        </button>
    </p-card>

    <!-- ── PREVIEW DIALOG ─────────────────────────────────────────────────── -->
    <p-dialog header="Content Preview" [(visible)]="previewVisible"
        [modal]="true" [style]="{width: '80vw', maxWidth: '900px'}"
        [draggable]="false" [resizable]="false">
        <div *ngIf="previewLoading" class="text-center py-4">
            <i class="pi pi-spin pi-spinner" style="font-size:2rem"></i>
        </div>
        <div *ngIf="!previewLoading && previewItem" class="preview-meta mb-3">
            <strong>{{previewItem.contentTypeLabel}}</strong>
            &nbsp;|&nbsp;{{previewItem.locationDisplay}}
            &nbsp;|&nbsp;Version: <code>{{previewItem.promptVersionKey}}</code>
        </div>
        <div *ngIf="!previewLoading" class="preview-body" [innerHTML]="previewHtml"></div>
        <ng-template pTemplate="footer">
            <button pButton type="button" label="Approve" icon="pi pi-check"
                class="p-button-success p-button-outlined me-2"
                (click)="approveContent(previewItem); previewVisible = false">
            </button>
            <button pButton type="button" label="Close" icon="pi pi-times"
                class="p-button-text"
                (click)="previewVisible = false">
            </button>
        </ng-template>
    </p-dialog>

    <!-- ── SECTION 2: CONTENT HEALTH ─────────────────────────────────────── -->
    <p-card header="Content Health" styleClass="mb-4">
        <div class="mb-3">
            <div class="d-flex justify-content-between align-items-center mb-1">
                <strong>Content Coverage</strong>
                <span>{{locationsWithContent}} / {{totalLocations}} locations</span>
            </div>
            <p-progressBar [value]="coveragePct" [showValue]="true"></p-progressBar>
        </div>

        <p-table [value]="locationHealthRows" [loading]="contentHealthLoading" responsiveLayout="scroll" styleClass="p-datatable-sm mb-3">
            <ng-template pTemplate="header">
                <tr>
                    <th>Location Name</th>
                    <th>Guides</th>
                    <th>FAQs</th>
                    <th>Has Description</th>
                    <th>Last Updated</th>
                    <th>Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td>{{row.locationName}}</td>
                    <td>{{row.guides}}</td>
                    <td>{{row.faqs}}</td>
                    <td><i class="pi" [ngClass]="row.hasDescription ? 'pi-check text-success' : 'pi-minus text-muted'"></i></td>
                    <td>{{row.lastUpdated | date:'MM/dd/yyyy'}}</td>
                    <td><a [routerLink]="['/content-list']" class="p-button p-button-text p-button-sm">Edit</a></td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr><td colspan="6">No content health data available.</td></tr>
            </ng-template>
        </p-table>

        <button pButton type="button" label="View All Content" icon="pi pi-external-link"
            class="p-button-outlined"
            routerLink="/content-list">
        </button>
    </p-card>

    <!-- ── SECTION 3: IMAGE PIPELINE ─────────────────────────────────────── -->
    <p-card header="Image Pipeline" styleClass="mb-4">
        <div class="stats-row mb-3">
            <div class="stat-card">
                <div class="stat-value">27,389</div>
                <div class="stat-label">Total Images</div>
            </div>
            <div class="stat-card success">
                <div class="stat-value">94%</div>
                <div class="stat-label">WebP Enabled</div>
            </div>
            <div class="stat-card">
                <div class="stat-value">—</div>
                <div class="stat-label">Avg Response Time</div>
            </div>
            <div class="stat-card">
                <div class="stat-value">—</div>
                <div class="stat-label">Cache Hit Rate</div>
            </div>
        </div>

        <p class="text-muted mb-3">Lambda&#64;Edge v8 live on CloudFront E1W825V20QK9TO</p>

        <a href="#" class="p-button p-button-outlined p-button-sm" target="_blank" rel="noopener">
            View CloudFront Metrics
        </a>
    </p-card>

    <!-- ── SECTION 4: SEO / AEO HEALTH ───────────────────────────────────── -->
    <p-card header="SEO / AEO Health" styleClass="mb-4">
        <ul class="seo-checklist">
            @for (item of seoChecklist; track item.label) {
                <li class="seo-checklist-item">
                    <i class="pi me-2"
                        [ngClass]="item.done ? 'pi-check-circle seo-done' : 'pi-circle seo-pending'">
                    </i>
                    {{item.label}}
                </li>
            }
        </ul>

        <div class="mt-3">
            <button pButton type="button" label="View Lighthouse Report" icon="pi pi-chart-bar"
                class="p-button-outlined">
            </button>
        </div>
    </p-card>
</div>
